module.exports = __webpack_public_path__ + "static/media/Industry-Light.c9ef5dbf.eot";